<h1
  mat-dialog-title
  class="no-margin"
>
  Lista Competenze
  <mat-icon class="close-icon" (click)="onNoClick()">close</mat-icon>
</h1>

<div class="container">
  <p>
    <strong>Dettaglio {{data.event?.element.tipologia?.descrizione}}: </strong>
    <span>{{ data.event?.element?.descrizione }}</span>
  </p>
  <div class="margin-bottom-20">
    <mat-list *ngIf="listaCompetenze.length;else noData">
      <mat-list-item *ngFor="let item of listaCompetenze; let  i = index" matTooltip="{{item.descrizione}}">
        {{i+1}}. {{item.descrizione}}
      </mat-list-item>
    </mat-list>

    <ng-template #noData>
      <h3 style="text-align: center;margin-top: 50px">Nessuna competenza associata</h3>
    </ng-template>
  </div>
</div>
